import React from 'react';

const Heading = (props) => {
    return (
        <>
            <div className='flex items-center self-start'>
                <div className='w-12 h-[2px] bg-black translate-y-[4px]' ></div>
                <div className='text-[3rem] font-walbaum text-red-500 ml-4'>{props.numerSekcji}</div>
                <p className='text-[2.3rem] tracking-widest ml-6 font-beckman mt-2'>{props.tytul}</p>
            </div>
        </>
    );
}

export default Heading;
